import { render } from "./EditPackage.vue?vue&type=template&id=52e00574&scoped=true"
import script from "./EditPackage.vue?vue&type=script&lang=js"
export * from "./EditPackage.vue?vue&type=script&lang=js"

import "./EditPackage.vue?vue&type=style&index=0&id=52e00574&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e00574"]])

export default __exports__